var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "5jrv6yao7b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.283 2h-9.05C1.446 2 0 3.407 0 5.143v5.028c0 1.735 1.447 3.142 3.232 3.142h7.54a3.394 3.394 0 1 1 4.743-4.853V5.143C15.515 3.407 14.068 2 12.283 2z",
    fill: "url(#13b8llrhda)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#5jrv6yao7b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wazrc19bdc)",
    d: "M0 1.623h15.515V13.69H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "xrgrbizgpd",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 16,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.553 5.394c0-.416.337-.754.754-.754H13.21a.754.754 0 1 1 0 1.508H2.307a.754.754 0 0 1-.754-.754zm2.325 3.771c0-.416.338-.754.755-.754h.043a.754.754 0 1 1 0 1.508h-.043a.754.754 0 0 1-.755-.754zm12.123 1.912a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0zm-2.35.301v1.081a.317.317 0 0 1-.317.315.317.317 0 0 1-.318-.315v-1.081h-1.091a.32.32 0 0 1-.288-.317c0-.163.124-.3.288-.317h1.087V9.666a.32.32 0 0 1 .32-.286.32.32 0 0 1 .32.286v1.078h1.09a.32.32 0 0 1 .289.317.32.32 0 0 1-.289.317h-1.09z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#xrgrbizgpd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#inc2mfwrle)",
    d: "M1 4.611h15v10H1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "13b8llrhda",
    x1: 0,
    y1: 2,
    x2: 0,
    y2: 13.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wazrc19bdc",
    x1: 0,
    y1: 1.623,
    x2: 0,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inc2mfwrle",
    x1: 1,
    y1: 4.611,
    x2: 1,
    y2: 14.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddCreditCard);
export default __webpack_public_path__ + "static/media/ic-add-credit-card.681e2979624f43f810a5f22dff79af61.svg";
export { ForwardRef as ReactComponent };